<template>
   <div class="d-flex flex-column flex-root">

      <Loader v-bind:logo="loaderLogo" v-if="utils.is_page_loading"></Loader>

      <div v-else>

         <!-- view -->
         <template v-if="utils.report_data != null">
            <template v-if="utils.report_data.status === 'active'">
               <router-view></router-view>
            </template>

            <!-- invitation expired -->
            <template v-else="utils.report_data.status === 'done'">
               <div class="row">
                  <div class="col-centered text-center">
                     <div class="custom-title-min-width pt-7">
                        Invitation as been signed
                     </div>
                  </div>
               </div>
            </template>
         </template>

         <!-- invitation done -->
         <template v-else>
            <div class="row">
               <div class="col-centered text-center">
                  <div class="custom-title-min-width pt-7">
                     Invitation not found!
                  </div>
               </div>
            </div>
         </template>

      </div>

   </div>
</template>


<script>

   import {mapGetters} from "vuex";
   import Loader from "@/view/content/Loader.vue";
   import {
      ADD_BODY_CLASSNAME,
      REMOVE_BODY_CLASSNAME
   } from "@/core/store/modules/htmlclass";
   import {
      SIGNPROOF_FETCH_INVITATION_DATA
   } from "../../core/store/modules/report.signproof";

   export default {
      name: "InvitationLayout",
      data() {
         return  {
            utils: {
               report_data: {},
               is_page_loading: true,
            }
         }
      },
      components: {
         Loader
      },
      computed: {
         ...mapGetters([
            "layoutConfig",
            "fetchedReportData",
            "fetchedInvitationData"
         ]),
         loaderLogo() {
            return process.env.BASE_URL + this.layoutConfig("loader.logo");
         }
      },
      beforeMount() {
         this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
         this.$store.dispatch(SIGNPROOF_FETCH_INVITATION_DATA, this.$router.currentRoute.params.invid);
      },
      watch: {
         'fetchedReportData'() {
            console.log(this.fetchedReportData);
            console.log(this.fetchedInvitationData);
            this.utils.is_page_loading = false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.utils.report_data = this.fetchedInvitationData;
         }
      }
   }
</script>


<style scoped>

</style>